export const RouteNames = {
	SIGNIN: '/signin-oidc',
	SIGNOUT: '/signout-oidc',
	SILENT_RENEW: '/silent-renew-oidc',
	ACCESS_REQUIRED: '/access-required',
	MAINTENANCE: '/maintenance',
	NOT_FOUND: '/404',
	DASHBOARD: '/',
	ORDERS: '/orders',
	ORDER_DETAILS: 'orders/:orderId/:source',
	PRODUCTS: '/products',
	PRODUCT_DETAILS: '/products/:productId',
	SEARCH: '/search/:searchKey/*',
	ACCOUNT: '/account/me',
	CONTACT: '/contact/us',
	IMPERSONATE: '/account/impersonate',
};
